import createReducer from 'store/create-reducer';
import { sessionService } from 'redux-react-session';
import apiFetch from 'utils/apiFetch';
import { loadingAction } from 'store/globalState/global';
import { setIsAuthenticated } from 'modules/app';
import { SET_AVATAR, SET_ERROR, SET_SUCCESS } from './types';

const INITIAL_STATE = {
  avatar: '',
  error: false,
  success: false,
};

export const doSignup = ({
  name, surname, email, password, lang, avatar, linkedin, invitation,
}) => (dispatch, getState) => {
  const data = {
    name,
    surname,
    email,
    password,
    instanceCode: getState().app.code,
    avatar,
    lang,
    linkedin,
    invitation,
  };

  return apiFetch('POST', { endPoint: 'users' }, data)
    .then((response) => {
      sessionService.saveSession({ token: response.user_code })
        .then(() => {
          const user = Object.assign({}, response);
          user.instance = getState().app.id;
          sessionService.saveUser(user)
            .then(() => {
              dispatch(setIsAuthenticated(true));
              dispatch({ type: SET_SUCCESS, success: true });
              window.sendUserIdentifier(user.id);
            });
        });
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      dispatch({ type: SET_ERROR, error: error.response.data });
      throw error;
    });
};

export const doSignupSocial = () => (dispatch, getState) => {
  dispatch(loadingAction(true));
  const data = {
    instanceCode: getState().app.code,
  };
  return apiFetch('POST', { endPoint: 'users/signup/social' }, data)
    .then((response) => {
      sessionService.saveSession({ token: response.user_code })
        .then(() => {
          const user = Object.assign({}, response);
          user.instance = getState().app.id;
          sessionService.saveUser(user)
            .then(() => {
              dispatch(loadingAction(false));
              dispatch(setIsAuthenticated(true));
              dispatch({ type: SET_SUCCESS, success: true });
            });
        });
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      dispatch({ type: SET_ERROR, error: error.response.data });
    });
};

export const uploadImage = (data, name) => (dispatch) => {
  const params = {
    data,
    name,
  };
  dispatch(loadingAction(true));
  apiFetch('POST', { endPoint: 'upload-file' }, params)
    .then((response) => {
      dispatch(loadingAction(false));
      dispatch({ type: SET_AVATAR, avatar: response.url });
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      dispatch({ type: SET_ERROR, error: error.response.data });
    });
};

const ACTION_HANDLERS = {
  [SET_AVATAR]: (state, { avatar }) => ({
    ...state,
    avatar,
  }),
  [SET_ERROR]: (state, { error }) => ({
    ...state,
    error,
  }),
  [SET_SUCCESS]: (state, { success }) => ({
    ...state,
    success,
  }),
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/routes/Signup/modules/signup.js